import auth from '../apis/auth';
import errorObject from '../components/helpers/errorObject';
import {
    SHOW_ERROR
} from './types'


export async function postAction(url, type, formValues, dispatch) {
    await auth.post(url, formValues)
        .then(response => {
            dispatch({ type: type, payload: response.data })
        })
        .catch(error => {
            if (error.response.data.detail.constructor === Array) {
                const errorObj = errorObject(error.response.data.detail)
                dispatch({ type: SHOW_ERROR, payload: errorObj })
            }
            else {
                dispatch({ type: SHOW_ERROR, payload: error.response.data });
            }
        })
}

export async function deleteAction(url, type, dispatch) {
    await auth.delete(url)
        .then(response => {
            dispatch({ type: type, payload: response.data })
        })
        .catch(error => {
            dispatch({ type: SHOW_ERROR, payload: error.response.data });
        })
}

export async function getAction(url, type, dispatch) {
    await auth.get(url)
        .then(response => {
            dispatch({ type: type, payload: response.data })
        })
        .catch(error => {
            dispatch({ type: SHOW_ERROR, payload: error.response.data });
        })
}